import { render, staticRenderFns } from "./authenticate.vue?vue&type=template&id=6a266207"
import script from "./authenticate.vue?vue&type=script&lang=js"
export * from "./authenticate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports